import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {ClipLoader} from "react-spinners";
import Button from "../../../../components/Common/Button";
import {genders as genderDataset} from "../../../../db/datasets/genders";
import {StudentInterface} from "../../../../db/models/student/student";
import {selectUid} from "../../../../slices/auth";
import {updateUser} from "../../../../api/user";
import "./style.scss";

interface Props {
    handleGoNext: Function;
}

type FormInterface = {
    name: string;
    surname: string;
    genderId: number;
};

const StudentOnboardingGeneral = ({handleGoNext}) => {
    const [loading, setLoading] = useState(false);
    const [ongoingFlag, setOngoingFlag] = useState(true);
    const uid = useSelector(selectUid);
    const {t} = useTranslation();

    const {register, handleSubmit, control, errors, reset, getValues} = useForm();


    const onSave = async (form: any) => {
        const name = form.name.trim() + "_" + form.surname.trim();
        const updatedUser: Partial<StudentInterface> = {
            name,
            genderId: Number(form.genderId),
            phone: form.phone,
        };

        try {
            setLoading(true);
            await updateUser(updatedUser);
            setLoading(false);
            handleGoNext();
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    return (
        <div className="studentOnboardingGeneral dark-bg">
            <div className="container">
                <div className="card p-4 mt-5">
                    <div className={"mb-5"}>
                        <h2 className="fs-1 fw-bolder mb-3">{t("student_onboarding_welcome_title")}</h2>
                        <p>{t("student_onboarding_welcome_p1")}</p>
                        <p>{t("student_onboarding_welcome_p2")}</p>
                    </div>
                    <form onSubmit={handleSubmit(onSave)}>
                        <div className="element">
                            <div className="label">{t("signup_student_name_label") + "*"}</div>
                            <input type="text" placeholder={t("signup_student_name_ph")}
                                   className={errors.name ? "input--error" : ""} name="name"
                                   ref={register({required: true})}/>
                            {errors.name && <span className="error">{t("signup_student_name_error")}</span>}
                        </div>
                        <div className="element">
                            <div className="label">{t("signup_student_surname_label") + "*"}</div>
                            <input type="text" className={errors.surname ? "input--error" : ""}
                                   placeholder={t("signup_student_surname_ph")} name="surname"
                                   ref={register({required: true})}/>
                            {errors.surname && <span className="error">{t("signup_student_surname_error")}</span>}
                        </div>
                        <div className="element">
                            <div className="label">{t("signup_student_gender_label") + "*"}</div>
                            <select name="genderId" ref={register({required: true})}>
                                <option selected value="">
                                    {t("select_choose_option")}
                                </option>
                                {genderDataset.map((gender) => (
                                    <option key={gender.id} value={gender.id}>
                                        {t(gender.label)}
                                    </option>
                                ))}
                            </select>
                            {errors.genderId && <span className="error">{t("signup_student_gender_error")}</span>}
                        </div>
                        <div className="element">
                            <div className="label">{t("signup_student_phone_label") + "*"}</div>
                            <input type="tel" className={`mw-100 ${errors.surname ? "input--error" : ""}`}
                                   placeholder={t("signup_student_phone_ph")} name="phone"
                                   ref={register({required: true})}/>
                            {errors.phone && <p className="error">{t("signup_student_phone_error")}</p>}
                        </div>
                        {!loading && (
                            <Button type="submit" filled loading={loading} backgroundColor="#3392E8"
                                    borderColor="#3392E8">
                                {t("student_onboarding_nextBtn")}
                            </Button>
                        )}
                        {loading && (
                            <div className="loader">
                                <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StudentOnboardingGeneral;
